import React from 'react';
import { withTranslation } from 'react-i18next';
import { Label, Table } from 'semantic-ui-react';

const QuantityWithUnitCell = ({ rowValues, entryRecord, index, t }) => {
  let unitLabel = <Label>{t('input.label.celsius')}</Label>;

  return (
    <Table.Cell key={rowValues.ID + index} className="tableCell tableCellReducedPadding2">
      {rowValues[entryRecord.key] !== 'null' ? (
        <>
          {t(rowValues[entryRecord.key])} {unitLabel}
        </>
      ) : (
        ''
      )}
    </Table.Cell>
  );
};

export default withTranslation()(QuantityWithUnitCell);
